import React/*, {useState}*/ from 'react';
import './customPanelToggleBtn.scss';

import classNames from "classnames";
import { connect } from 'react-redux';
// import $ from 'jquery';
//css and images

import { toggleItemVisibility, duplicateProject } from '../../actions';

class CustomPanelToggleBtn extends React.PureComponent {

    constructor(props, context) {
        super(props, context);
        this.handleCustomizeClicked = this.handleCustomizeClicked.bind(this);
    }

    handleCustomizeClicked(event) {
      let shouldShowCustomPanel = false;

      if (shouldShowCustomPanel) {
        this.props.toggleItemVisibility('mobileCustomPanel')
      } else {
        if (this.props.productId!==23) {
          let changes = this.props.customTexts;
          this.props.duplicateProject(this.props.projectCode, changes, this.props.currentProjectOptions, data => {
            if (data && data.status === 'Y') {
              //window.location.href = `${process.env.REACT_APP_ENGINE_HOST}` + data.url
              window.location.href =  data.url;
            }
          });
        }
      }
      event.preventDefault();
      return false;
    }

    render() {
      return (<div className="row mb-4 mt-2">
          <div className="col text-center pr-0 customise-further">
              {this.props.is_customise_further?
                  <div className="d-inline-block mr-md-2">
                      <button className={classNames("badge-pill btn form-control add-to-cart-btn confirm-button-selector", {"btn-outline-dark w-auto hover-outline-danger" : !this.props.isCustomPanel, "btn-default": this.props.isCustomPanel})} type="button" onClick={this.handleCustomizeClicked}>Customise Further</button>
                  </div>
                  :''}
              <div className="d-sm-inline-block d-none">
                <button className="add-to-cart-btn badge-pill btn btn-success form-control h5 font-weight-bold px-3 mt-2 my-lg-0 w-auto"
                        style={{letterSpacing: '1px', fontSize: '16px'}}>Add to Cart
                </button>
                <button className="sold-out-btn badge-pill btn btn-disabled form-control font-weight-bold px-5 mt-2 my-lg-0 w-auto" disabled
                        style={{display:'none'}}>Sold Out</button>
              </div>
              <div className="d-inline-block">
                <div className="sold-out-btn email-stock badge-pill btn btn-outline-light text-dark form-control font-weight-bold px-5 mt-2 my-lg-0 w-auto"
                      style={{display:'none'}}>Notify Me</div>
              </div>
              <input type="hidden" id="action" name="action" value=""/>
          </div>
      </div>);
    }
}

const mapStateToProps = state => {
  let currentDesignBackground = null;
  if (state.currentProjectOptions && state.projectOptions && state.projectOptions.images) {
      let imageData = state.projectOptions.images.find(image => {
          let match = true;
          for (let option in state.currentProjectOptions) {
              let variation = state.currentProjectOptions[option];
              if (image[option] !== variation) {
                  match = false;
                  break;
              }
          }
          return match;
      });
      if (imageData) {
          currentDesignBackground = imageData;
      }
  }

  let previewPage = 0;
  if (currentDesignBackground && currentDesignBackground.previews && state.previewPage && currentDesignBackground.previews[state.previewPage]) {
    previewPage = state.previewPage
  }
  return {
    pages: state.pages,
    is_customise_further: state.is_customise_further,
    currentDesignBackground: currentDesignBackground,
    previewPage: previewPage,
    customTexts: state.customTexts,
    currentProjectOptions: state.currentProjectOptions,
    projectCode: state.projectCode,
    productId: state.productId,
  }
};

const mapDispatchToProps = dispatch => ({
  toggleItemVisibility: (itemCode) => dispatch(toggleItemVisibility(itemCode)),
  duplicateProject: (hash, changes, variations, callback) => dispatch(duplicateProject(hash, changes, variations, callback)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CustomPanelToggleBtn);
